import { render, staticRenderFns } from "./Billing.vue?vue&type=template&id=613837ba&scoped=true"
import script from "./Billing.vue?vue&type=script&lang=js"
export * from "./Billing.vue?vue&type=script&lang=js"
import style0 from "./Billing.vue?vue&type=style&index=0&id=613837ba&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613837ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('613837ba')) {
      api.createRecord('613837ba', component.options)
    } else {
      api.reload('613837ba', component.options)
    }
    module.hot.accept("./Billing.vue?vue&type=template&id=613837ba&scoped=true", function () {
      api.rerender('613837ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/Billing.vue"
export default component.exports